import { render, staticRenderFns } from "./user_dpfw.vue?vue&type=template&id=813eacba&scoped=true"
import script from "./user_dpfw.vue?vue&type=script&lang=js"
export * from "./user_dpfw.vue?vue&type=script&lang=js"
import style0 from "./user_dpfw.vue?vue&type=style&index=0&id=813eacba&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "813eacba",
  null
  
)

export default component.exports